/**
 * Shared clipboard helper.
 *
 * `NotificationsModal.jsx` and `AboutModal.jsx` each inline
 * `navigator.clipboard.writeText` with their own try/catch; this is the third
 * call site, so it gets pulled out instead of copy-pasted a third time.
 */
export async function copyText(text) {
  if (!text) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
